import * as R from 'ramda'
import { useSelector } from 'react-redux'
import { Message } from '@weblite/ts-action/message'
import { getSharedMediaContentCounter } from '$logic/shared-media/service'
import { useAsyncFunction } from '$func/async-function.react-hook'
import { RootState } from '$setup/redux'
import { sharedMediaStorage } from '$logic/shared-media/shared-media.storage'
import { SharedMediaCategoryType } from '$logic/shared-media/types'

export function useSharedMediaContentsCount(roomId: string) {
  const { value: contentsCount, loading } = useAsyncFunction(async () => {
    const countByCategory = await getSharedMediaContentCounter(roomId)
    return {
      ...countByCategory,
      sharedMedia: countByCategory ? R.sum(R.values(countByCategory)) : null,
    }
  }, [roomId])

  return { loading, contentsCount }
}

const getOpenedRoomSharedMediaView = (state: RootState) =>
  state.main.openedRoomSharedMedia as Message[]

export function useOpenedRoomSharedMedia(
  roomId: string,
  category: SharedMediaCategoryType,
) {
  const items = useSelector(getOpenedRoomSharedMediaView)

  const { loading, value: sharedMediaObject } = useAsyncFunction(async () => {
    return sharedMediaStorage.get(roomId, category)
  }, [roomId, category, items])

  return {
    items,
    hasMoreItemToLoad: loading
      ? false
      : sharedMediaObject
        ? !sharedMediaObject.hasSeenFirst
        : !!items.length,
    loading,
  }
}
